var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.footer},[_c('h4',[_vm._v("Copyright ©"+_vm._s(_vm.toyear)+" 上海仪表电子专业技术人员（专业科目）继续教育网络学习平台 保留所有权利。")]),_vm._v(" "),_c('h4',[_vm._v("沪ICP备16000405号")]),_vm._v(" "),_c('h4',[_vm._v("如需帮助 联系管理员: 18930299913 或 minq.ydwl@inesa-it.com")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c9c0e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/others/footer.vue
// module id = null
// module chunks = 